(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-arrivals"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pv-carousel')) {
  customElements.define('pv-carousel', class extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.pv-car__card'));
      this.dots = Array.from(this.querySelectorAll('.pv-car__dot'));
      if (!this.cards.length) return;
      this.index = 0;
      this.dragged = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
      this.cards.forEach((card, i) => {
        card.addEventListener('click', (e) => {
          if (this.dragged) { e.preventDefault(); this.dragged = false; return; }
          if (i !== this.index) { e.preventDefault(); this.go(i); }
        });
      });
      const stage = this.querySelector('.pv-car__stage');
      let startX = null;
      stage.addEventListener('pointerdown', (e) => { startX = e.clientX; this.dragged = false; });
      stage.addEventListener('pointerup', (e) => {
        if (startX === null) return;
        const dx = e.clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) { this.dragged = true; this.go(this.index + (dx < 0 ? 1 : -1)); }
      });
      stage.addEventListener('pointercancel', () => { startX = null; });
      this.onResize = () => this.render();
      window.addEventListener('resize', this.onResize);
      this.render();
    }
    disconnectedCallback() { window.removeEventListener('resize', this.onResize); }
    go(i) {
      const n = this.cards.length;
      this.index = ((i % n) + n) % n;
      this.render();
    }
    render() {
      const n = this.cards.length;
      const step = this.cards[0].offsetWidth * 0.94;
      const scales = [1, 0.84, 0.7];
      const opacities = [1, 0.95, 0.55];
      const tops = [0, 26, 52];
      this.cards.forEach((card, i) => {
        let off = i - this.index;
        if (off > n / 2) off -= n;
        if (off < -n / 2) off += n;
        const d = Math.abs(off);
        const visible = d <= 2;
        card.style.transform = 'translateX(calc(-50% + ' + (off * step) + 'px)) scale(' + (visible ? scales[d] : 0.6) + ')';
        card.style.zIndex = String(10 - d);
        card.style.opacity = visible ? String(opacities[d]) : '0';
        card.style.top = (visible ? tops[d] : 52) + 'px';
        card.style.pointerEvents = visible ? 'auto' : 'none';
        card.classList.toggle('is-active', d === 0);
        card.tabIndex = d === 0 ? 0 : -1;
        card.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
        dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-picks"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pv-tabs')) {
  customElements.define('pv-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const n = this.tabs.length;
            const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + n) % n;
            this.select(next);
            this.tabs[next].focus();
          }
        });
      });
      this.onBlockSelect = (e) => {
        const i = this.tabs.findIndex((t) => t.dataset.blockId === e.detail.blockId);
        if (i > -1) this.select(i);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }
    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
